import { EZChat, EZChatProvider } from "@axl/ez-chat-for-school";
import "@axl/ez-chat-for-school/dist/ez-chat-for-school.css";
import { FC } from "react";

import { useChat } from "@app/features/chat/ChatProvider";
import { useDevice } from "@app/shared/providers/DeviceProvider";
import {
  useFileProvider,
  useLang,
  useLoc,
  useSdk,
  useSettings,
  useTokenStorage,
} from "@app/shared/lib/hooks";
import { ErrorBoundary } from "@app/shared/ui/ErrorBoundary";

export const Chat: FC = () => {
  const loc = useLoc();
  const fileProvider = useFileProvider();
  const settings = useSettings();
  const device = useDevice();
  const chat = useChat();
  const sdk = useSdk();
  const tokenStorage = useTokenStorage();

  const { lang } = useLang();

  if (!tokenStorage.accessToken) return null;

  return (
    <ErrorBoundary fallback={null}>
      <EZChatProvider
        lang={lang}
        loc={loc}
        fileProvider={fileProvider}
        deviceStore={device}
        tokenStore={{ accessToken: tokenStorage.accessToken as string }}
        settings={settings.chat}
        fileApi={sdk.api.file}
      >
        <ErrorBoundary fallback={null}>
          <EZChat
            handler={(x: any) => chat.setChatController(x)}
            defaultPosition={{ top: 70, right: 10 }}
            floating
          />
        </ErrorBoundary>
      </EZChatProvider>
    </ErrorBoundary>
  );
};
